import React from 'react'
import { Link } from 'react-router-dom';

// import image
import background from '../asset/images/hero_banner.png';

const Hero = () => {
  return (
    <section id='hero-section' className='hero-image' style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${background})` }}>
      <div className='hero-text'>
        <h1>I'm Abdul Khaliq</h1>
        <p>And I'm a Full Stack Developer</p>
        <p>Lahore, Pakistan</p>
        <Link to="/contact-me" className='hero-btn'>Hire Me</Link>
      </div>
    </section>
  )
}

export default Hero

